import Controller from '../abstracts/Controller';
import 'scss-templates/t-contact-us.scss';


export default class ContactUsController extends Controller {
  static get COMPONENTS() {
    return [
      'DatePickerComponent',
      'RecaptchaComponent',
      'ContactUsComponent',
      'NewPrivacyComponent',
      'DropdownComponent',
      'CustomSelectComponent'
    ];
  }

}
